<template>
  <div class="beer-collect-wrapper" :style="`padding-top:${barHeight}px`">
    <van-nav-bar class="van-bar" left-arrow @click-left="closeWeb">
      <template #left>
        <img class="left-nav" src="@/assets/packageAssets/common/arrow02.png" alt="back" />
      </template>
    </van-nav-bar>

    <!-- 内容 -->
    <div class="content-wrapper">
      <!-- 标题 -->
      <!-- <div class="title-wrapper">{{ $t('lang.beer.title') }}</div> -->
      <MyPLabel class="title-wrapper" :str="$t('lang.beer.title')" :customClass="{ beer: 'beeract-title-beer' }" />
      <!-- 商品内容 -->
      <div class="goods-wrapper">
        <!-- 我的个数 -->
        <div class="mine-wrapper">
          <span>{{ $t('lang.beer.left') }}：</span>
          <img src="./images/beer.png" alt="icon" width="18" height="18" />
          <span>&nbsp;{{ beerRemainAmount }}</span>
        </div>
        <!-- 获取提示 -->
        <!-- <div class="tips-wrapper">{{ $t('lang.beer.tips') }}</div> -->
        <MyPLabel class="tips-wrapper" :str="$t('lang.beer.tips')" :customClass="{ beer: 'beeract-tips-beer' }" />
        <!-- 商品列表 -->
        <div class="goods-list">
          <div v-if="goodsLoading" class="goods-loading-wrapper">
            <van-loading />
          </div>
          <template v-else>
            <template v-for="item in goodsList">
              <div class="goods-item-wrap" :key="item.propType" @click="handleOpenPopup(item)">
                <div class="goods-item">
                  <!-- 蒙层 -->
                  <div class="shadow-mark" v-if="item.propType == 0 && ifExchangeCoinToday">
                    {{ $t('lang.beer.comeTomorrow') }}
                  </div>
                  <!-- 提示 -->
                  <div class="item-title">
                    <template v-if="item.propType == 0">
                      <span>{{ $t('lang.beer.onceDaily') }}</span>
                    </template>
                    <template v-else>
                      <span>{{ $t('lang.beer.unlimited') }}</span>
                    </template>
                  </div>
                  <div class="item-image">
                    <img :src="handleCheckType(item.propType).image" width="50" height="50" alt="icon" />
                    <div class="item-number">x{{ item.rewardAmount }}</div>
                  </div>
                  <div :class="['item-footer', beerRemainAmount < item.costBeerAmount ? 'item-footer-off' : '']">
                    <span>{{ $t('lang.beer.redeem') }}&nbsp;(</span>
                    <img src="./images/beer.png" alt="icon" width="18" height="18" />
                    <span>x{{ item.costBeerAmount }})</span>
                  </div>
                </div>
              </div>
            </template>
          </template>
        </div>
      </div>
      <!-- 兑换历史 -->
      <div class="history-wrapper">
        <!-- 标题 -->
        <!-- <div class="title">{{ $t('lang.beer.historyTitle') }}</div> -->
        <div class="title">
          <MyPLabel :str="$t('lang.beer.historyTitle')" :customClass="{ beer: 'beeract-histit-beer' }" />
        </div>
        <!-- 历史列表 -->
        <div class="history-list-wrapper">
          <van-list
            class="list-wrapper"
            v-model="historyloading"
            :finished="historyFinished"
            :loading-text="' '"
            :finished-text="historyList.length > 5 ? $t('lang.noMore') : ' '"
            offset="100"
            @load="handleGetHistoryMore"
          >
            <template v-for="item in historyList">
              <div :key="item.propType" class="history-item">
                <div class="item-left">
                  <img :src="handleCheckType(item.propType).image" alt="icon" width="36" height="36" />
                  <span class="item-title">{{ handleCheckType(item.propType).title }}{{ item.rewardAmount > 1 && item.propType !== 0 ? `*${item.rewardAmount}` : '' }}</span>
                </div>
                <div class="item-right">
                  <div class="item-info">
                    <span>{{ item.costBeerAmount }}&nbsp;</span>
                    <img src="./images/beer.png" alt="icon" width="18" height="18" />
                  </div>
                  <span class="item-time">{{ item.exchangeTime || '-' }}</span>
                </div>
              </div>
            </template>
          </van-list>
        </div>
      </div>
    </div>

    <!-- 弹窗 -->
    <van-dialog v-model="popupVisible" title="" :className="'beer-van-dia'" :showConfirmButton="false" :showCancelButton="false">
      <div class="dialog-wrapper">
        <div class="title-wrapper">{{ $t('lang.beer.confirmRedemption') }}</div>
        <div class="content-wrapper">
          <div class="image-wrapper">
            <img :src="handleCheckType(currentItem.propType).image" alt="beet" width="40" height="40" />
          </div>
          <div class="text-wrapper">{{ handleCheckType(currentItem.propType).title }} x {{ submitNumber }}</div>
          <div class="number-wrapper">
            <van-stepper v-model="submitNumber" step="1" min="1" button-size="40px" :max="maxNumber" integer disable-input :disabled="currentItem.propType === 0" />
          </div>
        </div>
        <div class="footer-wrapper">
          <div class="button-wrapper confirm" @click="handleSubmit">
            {{ $t('lang.confirm') }}
          </div>
          <div class="button-wrapper cancel" @click="handleClosePopup">
            {{ $t('lang.cfm.cancelBtn') }}
          </div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { apiBeerExchangeList, apiBeerExchangeHistory, apiBeerExchange } from './apidir/api.js'
import goodsA from './images/props-message.png'
import goodsB from './images/props-video.png'
import goodsC from './images/props-call.png'
import goodsD from './images/props-coin.png'
import goodsE from './images/props-diamond.png'
import goodsF from './images/props-message2.png'

const mockList = [
  {
    propType: 0,
    rewardAmount: 12,
    costBeerAmount: 12,
    exchangeTime: '2025.12.02'
  },
  {
    propType: 1,
    rewardAmount: 21,
    costBeerAmount: 21,
    exchangeTime: '2025.12.02'
  },
  {
    propType: 2,
    rewardAmount: 21,
    costBeerAmount: 21,
    exchangeTime: '2025.12.02'
  },
  {
    propType: 5,
    rewardAmount: 21,
    costBeerAmount: 21,
    exchangeTime: '2025.12.02'
  },
  {
    propType: 15,
    rewardAmount: 21,
    costBeerAmount: 21,
    exchangeTime: '2025.12.02'
  }
]

export default {
  name: 'beer-collect',
  data() {
    const queryParam = this.$route.query.appName || ''
    return {
      goodsMap: [
        { image: goodsA, title: 'Chat Pass' },
        { image: goodsB, title: 'Match Pass' },
        { image: goodsC, title: 'Call Pass' },
        { image: this.isIOS(queryParam) ? goodsE : goodsD, title: this.isIOS(queryParam) ? '100 Gems' : '100 Coins' },
        { image: goodsF, title: 'Super Chat Pass' }
      ],
      beerRemainAmount: 0, // 我的啤酒量
      ifExchangeCoinToday: false, // 今天是否已经换完最终大奖
      goodsLoading: false,
      goodsList: [], // 礼物列表
      popupVisible: false,
      currentItem: {},
      historyList: [], // 历史列表
      mockHisList: mockList,
      rollParams: {
        offset: 0,
        limit: 10
      },
      historyloading: true,
      historyFinished: true,
      submitNumber: 1, // 提交兑换的个数
      maxNumber: 1 // 最大的个数
    }
  },
  computed: {
    /**
     * @description 代码描述 0=金币 1=CHATPASS 2=MATCHPASS 6=CALLPASS
     */
    handleCheckType() {
      return (type) => {
        switch (type) {
          case 0:
            return this.goodsMap[3]
          case 1:
            return this.goodsMap[0]
          case 2:
            return this.goodsMap[1]
          case 6:
            return this.goodsMap[2]
          case 15:
            return this.goodsMap[4]
          default:
            return this.goodsMap[0]
        }
      }
    },
    /**
     * @description 判断是否禁止修改兑换数量
     */
    handleCheckExchange() {
      if (!this.currentItem.costBeerAmount) {
        return true
      }
      if (this.currentItem.propType === 0) {
        return true
      }
      if ((this.submitNumber + 1) * this.currentItem.costBeerAmount > this.beerRemainAmount) {
        return true
      }
      return false
    }
  },
  mounted() {
    this.handleGetList()
    this.handleGetHistory()
  },
  methods: {
    isIOS(value) {
      const iosAppName = ['com.fh.whisper.chat', 'com.example.echo']
      return iosAppName.includes(value)
    },
    /**
     * @description 获取列表
     */
    async handleGetList() {
      try {
        this.goodsLoading = true
        const res = await apiBeerExchangeList()
        const resData = res.propCfgList || []
        this.beerRemainAmount = res.beerRemainAmount || 0
        this.ifExchangeCoinToday = res.ifExchangeCoinToday
        this.goodsList = resData
      } catch (error) {
        console.error(error)
      } finally {
        this.goodsLoading = false
      }
    },
    /**
     * @description 打开兑换弹窗
     */
    handleOpenPopup(item) {
      // 是否已兑换完
      if (item.propType === 0 && this.ifExchangeCoinToday) {
        return false
      }
      // 是否啤酒不够
      if (item.costBeerAmount > this.beerRemainAmount) {
        this.$client.showToast(this.$t('lang.beer.errorText'))
        return false
      }
      let max = Math.floor(this.beerRemainAmount / item.costBeerAmount)
      if (max === 0) max = 1
      if (item.propType === 0) max = 1
      this.maxNumber = max
      this.submitNumber = 1
      this.currentItem = item
      this.popupVisible = true
    },
    /**
     * @description 关闭兑换弹窗
     */
    handleClosePopup() {
      this.popupVisible = false
      setTimeout(() => {
        this.currentItem = {}
      }, 300)
    },

    /**
     * @description 提交兑换
     */
    async handleSubmit() {
      try {
        try {
          this.handleClosePopup()
          const propType = this.currentItem.propType
          const propId = this.currentItem.propId
          await apiBeerExchange(propType, propId, this.submitNumber)
          this.$client.showToast(this.$t('lang.beer.redeemed'))
          this.handleGetList()
          this.handleGetHistory()
        } catch (error) {
          this.$client.showToast(error)
        }
      } catch (error) {
        console.error(error)
      }
    },
    /**
     * @description 获取历史记录
     */
    async handleGetHistory() {
      try {
        this.historyFinished = false
        this.historyloading = true
        this.rollParams.offset = 0
        const res = await apiBeerExchangeHistory({ offset: 0, limit: this.rollParams.limit })
        const resData = res || []
        if (Array.isArray(resData)) {
          this.historyList = resData
        } else {
          this.historyFinished = true
        }
        // 返回数量小于limit就说明到底了
        if (resData.length < this.rollParams.limit) {
          this.historyFinished = true
        }
      } catch (error) {
        this.historyFinished = true
        console.error(error)
      } finally {
        this.historyloading = false
      }
    },
    /**
     * @description 获取历史记录-更多
     */
    async handleGetHistoryMore() {
      try {
        if (this.historyList.length === 0) {
          return
        }
        this.historyloading = true
        this.rollParams.offset = this.historyList.length
        const res = await apiBeerExchangeHistory({ offset: this.rollParams.offset, limit: this.rollParams.limit })
        const resData = res || []
        if (Array.isArray(resData) && resData.length > 0) {
          this.historyList = this.historyList.concat(resData)
          // 返回数量小于limit就说明到底了
          if (resData.length < this.rollParams.limit) {
            this.historyFinished = true
          }
        } else {
          this.historyFinished = true
        }
      } catch (error) {
        this.historyFinished = true
        console.error(error)
      } finally {
        this.historyloading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import './styles/index.scss';
</style>

<style lang="scss">
.custom-p-label {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.beeract-title-beer {
  width: 32px;
  height: 32px;
  margin: 0 4px;
}

.beeract-tips-beer {
  width: 20px;
  height: 20px;
  margin: 0 6px;
}

.beeract-histit-beer {
  width: 30px;
  height: 30px;
  margin: 0 6px;
}

.beer-van-dia {
  width: 315px;
}
</style>
